import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { theme } from '../styled/theme';
import { Container, AutoGrid } from '../styled/BaseComponents';

const neonPulse = keyframes`
  0% {
    box-shadow: 0 0 0 rgba(0, 247, 210, 0), 0 0 0 rgba(92, 233, 255, 0);
  }
  50% {
    box-shadow: 0 0 22px rgba(0, 247, 210, 0.25), 0 0 36px rgba(92, 233, 255, 0.15);
  }
  100% {
    box-shadow: 0 0 0 rgba(0, 247, 210, 0), 0 0 0 rgba(92, 233, 255, 0);
  }
`;

const StatCardWrapper = styled.div`
  position: relative;
  overflow: hidden;
  transition: transform 0.35s ease;
  background: radial-gradient(
    100% 120% at 0% 0%,
    rgba(0, 247, 210, 0.09),
    rgba(92, 233, 255, 0.05) 50%,
    rgba(12, 16, 28, 0.6) 100%
  );
  border: 1px solid ${theme.colors.border};
  border-radius: 1rem;
  padding: 1.35rem;
  text-align: center;
  animation: ${neonPulse} 3.2s ease-in-out infinite;

  &:hover {
    transform: translateY(-3px) scale(1.02);
  }
`;

const StatValue = styled.div`
  font-size: 1.9rem;
  font-weight: 900;
  line-height: 1;
  background: linear-gradient(90deg, ${({ color }) => color}, ${theme.colors.white});
  -webkit-background-clip: text;
  color: transparent;
`;

const StatLabel = styled.div`
  color: ${theme.colors.muted};
  font-size: 13px;
  margin-top: 8px;
  letter-spacing: 0.3px;
`;

const StatCard = ({ label, value, color }) => {
  const [display, setDisplay] = useState('0');

  useEffect(() => {
    const end = parseFloat(String(value).replace(/[^0-9.]/g, '')) || 0;
    const isSmall = end <= 50;
    const frames = 50;
    let step = 0;

    const timer = setInterval(() => {
      step++;
      const cur = end * (step / frames);
      setDisplay(
        isSmall ? cur.toFixed(2) : Intl.NumberFormat('en-US').format(Math.floor(cur))
      );
      if (step >= frames) {
        clearInterval(timer);
        setDisplay(String(value));
      }
    }, 24);

    return () => clearInterval(timer);
  }, [value]);

  return (
    <StatCardWrapper>
      <StatValue color={color}>{display}</StatValue>
      <StatLabel>{label}</StatLabel>
    </StatCardWrapper>
  );
};

const StatsWrapper = styled.section`
  margin-top: 1.5rem;
`;

export const StatsModern = ({ statsData }) => {
  // Default stats if no data provided
  const defaultStats = [
    { label: 'Users', value: '0', color: '#5ce9ff' },
    { label: 'Total Volume', value: '$0', color: '#00f7d2' },
    { label: 'Total Stores', value: '0', color: '#5ce9ff' },
    { label: 'OTC Marketplace', value: '0', color: '#00f7d2' },
  ];

  const stats = statsData || defaultStats;

  return (
    <StatsWrapper>
      <Container>
        <AutoGrid>
          {stats.map((stat) => (
            <StatCard key={stat.label} {...stat} />
          ))}
        </AutoGrid>
      </Container>
    </StatsWrapper>
  );
};

export default StatsModern;

